import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProjectProvider } from './projects/ProjectContext';
import { getRuntimeConfig } from './config/runtimeConfig';

const publishableKey = getRuntimeConfig().clerkPublishableKey;
if (!publishableKey) {
  // eslint-disable-next-line no-console
  console.error('Missing clerkPublishableKey in /config.json (frontend.clerkPublishableKey)');
}

const el = document.getElementById('root');
if (!el) throw new Error('Missing #root element');
const root = ReactDOM.createRoot(el);
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={publishableKey || ''}
      appearance={{
        variables: {
          colorPrimary: '#a855f7',
          colorBackground: '#05060a',
          colorText: '#e9e7ff',
          colorTextSecondary: 'rgba(233, 231, 255, 0.72)',
          colorInputBackground: 'rgba(255,255,255,0.04)',
          colorInputText: '#e9e7ff',
          borderRadius: '12px',
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        },
        elements: {
          formButtonPrimary: {
            borderRadius: '12px',
            backgroundImage:
              'linear-gradient(90deg, rgba(168, 85, 247, 1) 0%, rgba(99, 102, 241, 1) 45%, rgba(34, 211, 238, 1) 100%)',
          },
          socialButtonsBlockButton: {
            borderRadius: '12px',
            border: '1px solid rgba(168, 85, 247, 0.22)',
            backgroundColor: 'rgba(168, 85, 247, 0.06)',
          },
          socialButtonsBlockButtonText: {
            color: '#e9e7ff',
            fontWeight: 700,
          },
          socialButtonsBlockButtonArrow: {
            color: 'rgba(233, 231, 255, 0.85)',
          },
          userButtonAvatarBox: {
            border: '1px solid rgba(255,255,255,0.18)',
          },
          userButtonPopoverCard: {
            backgroundColor: '#0b0c12',
            border: '1px solid rgba(168, 85, 247, 0.20)',
            boxShadow: '0 18px 60px rgba(0,0,0,0.65)',
            color: '#e9e7ff',
          },
          userButtonPopoverActionButton: {
            color: '#e9e7ff',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.08)',
            },
          },
          userButtonPopoverActionButtonText: {
            color: '#e9e7ff',
            fontWeight: 700,
          },
          userButtonPopoverFooter: {
            color: 'rgba(233,231,255,0.70)',
          },
        },
      }}
    >
      <ProjectProvider>
        <App />
      </ProjectProvider>
    </ClerkProvider>
  </React.StrictMode>
);

reportWebVitals(); 